import {
  FIELD_VALUES,
  URL_PARAM_APPLICANT_ID,
  URL_PARAM_APPLICANT_TYPE,
  URL_PARAM_APPLICATION_ID,
} from '@funnels/constants';
import { FunnelConfig } from '@funnels/types';
import {
  AccountantLayout,
  AccountDetails,
  ApplicantLayout,
  ConveyancerLayout,
  PostProductSelectSummary,
  PropertyLayout,
} from '@funnels/ui-layouts/customer-view/PostProductSelect';
import { getDashboardUrl } from '@funnels/utils';

import { PAGE_TITLE } from './constants';

const baseName = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/:entity(borrower-summary|guarantor-summary|summary-edit)/:${URL_PARAM_APPLICANT_TYPE}?/:entity(applicant|accountant)?/:${URL_PARAM_APPLICANT_ID}?`;

const getSummaryURL = (targetApplicantType: string) => {
  return `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/${targetApplicantType.toLowerCase()}-summary/`;
};

const summaryEditConfig: FunnelConfig = {
  baseName,
  entryPoint: () => `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/borrower-summary/`,
  questions: [
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/borrower-summary/`,
      component: () => <PostProductSelectSummary targetApplicantRole={FIELD_VALUES.BORROWER} />,
      target: (_values: any, { params }) => {
        const applicationId = params![URL_PARAM_APPLICATION_ID];
        return { url: getDashboardUrl(applicationId), hardRedirect: true };
      },
      pageTitle: PAGE_TITLE.borrowerPostProductSummary,
    },
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/guarantor-summary/`,
      component: () => <PostProductSelectSummary targetApplicantRole={FIELD_VALUES.GUARANTOR} />,
      target: (_values: any, { params }) => {
        const applicationId = params![URL_PARAM_APPLICATION_ID];
        return { url: getDashboardUrl(applicationId), hardRedirect: true };
      },
      pageTitle: PAGE_TITLE.guarantorPostProductSummary,
    },
    // pps summary edit flow
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/summary-edit/:${URL_PARAM_APPLICANT_TYPE}/applicant/:${URL_PARAM_APPLICANT_ID}/`,
      component: (props) => <ApplicantLayout {...props} isFromSummary />,
      target(values: any, { params }) {
        const targetApplicantType = params![URL_PARAM_APPLICANT_TYPE];
        return { url: getSummaryURL(targetApplicantType!) };
      },
      pageTitle: PAGE_TITLE.applicant,
    },
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/summary-edit/:${URL_PARAM_APPLICANT_TYPE}/property/`,
      component: (props) => <PropertyLayout {...props} isFromSummary />,
      target(values: any, { params }) {
        const targetApplicantType = params![URL_PARAM_APPLICANT_TYPE];
        return { url: getSummaryURL(targetApplicantType!) };
      },
      pageTitle: PAGE_TITLE.property,
    },
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/summary-edit/:${URL_PARAM_APPLICANT_TYPE}/conveyancer/`,
      component: (props) => <ConveyancerLayout {...props} isFromSummary />,
      target(values: any, { params }) {
        const targetApplicantType = params![URL_PARAM_APPLICANT_TYPE];
        return { url: getSummaryURL(targetApplicantType!) };
      },
      pageTitle: PAGE_TITLE.conveyancer,
    },
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/summary-edit/:${URL_PARAM_APPLICANT_TYPE}/accountant/:${URL_PARAM_APPLICANT_ID}/`,
      component: (props) => <AccountantLayout {...props} isFromSummary />,
      target(values: any, { params }) {
        const targetApplicantType = params![URL_PARAM_APPLICANT_TYPE];
        return { url: getSummaryURL(targetApplicantType!) };
      },
      pageTitle: PAGE_TITLE.accountant,
    },
    {
      url: `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/summary-edit/:${URL_PARAM_APPLICANT_TYPE}/account-details/`,
      component: (props) => <AccountDetails {...props} isFromSummary />,
      target(values: any, { params }) {
        const targetApplicantType = params![URL_PARAM_APPLICANT_TYPE];
        return { url: getSummaryURL(targetApplicantType!) };
      },
      pageTitle: PAGE_TITLE.accountDetails,
    },
  ],
};

export default summaryEditConfig;
